import React from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  name: 'Content Management System',
  us: true,
  them: true
}, {
  name: 'SEO-friendly URLs',
  us: true,
  them: 'Rarely'
}, {
  name: 'Built in Location / Custom SEO',
  us: true,
  them: 'Rarely'
}, {
  name: 'Inventory Syndication',
  us: true,
  them: true
}, {
  name: 'Boat detail pages',
  us: true,
  them: true
}, {
  name: 'Customizable Content on Boat Detail Pages',
  us: true,
  them: false
}, {
  name: 'Automatic inventory sync',
  us: true,
  them: false
}, {
  name: 'Lead capture + CRM integration',
  us: true,
  them: false
}, {
  name: 'Customizable Price Display',
  us: true,
  them: false
}, {
  name: 'WCAG 2.2 AA Compliant Websites',
  us: true,
  them: false
}, {
  name: 'Site Built with Speed and Core Web Vitals in Mind',
  us: true,
  them: false
}, {
  name: 'Digital Marketing Services',
  us: true,
  them: true
}, {
  name: 'Custom Product Schema (Rich Results in SERP)',
  us: true,
  them: false
}, {
  name: 'Limitless Customization with clean, SEO Optimized Code',
  us: true,
  them: false
}, {
  name: '24-7 Support - 365 days a year with on-call paging',
  us: true,
  them: false
}];
export function ComparisonTable() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-4">
            Don't Settle for Agencies That Don't Understand Boat Sales
          </h2>
          <p className="text-xl text-gray-600" data-id="element-5">
            Ahead of the competition with fast, custom, SEO-optimized websites and seamless inventory sync.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-6">
          <div className="min-w-[700px] rounded-xl overflow-hidden border border-gray-200 shadow-lg" data-id="element-7">
            <table className="w-full text-left border-collapse" data-id="element-8">
              <thead data-id="element-9">
                <tr data-id="element-10">
                  <th className="p-6 bg-gray-50 text-gray-500 font-semibold w-1/3" data-id="element-11">
                    Feature
                  </th>
                  <th className="p-6 bg-[#0A2540] text-white font-bold text-xl w-1/3 relative" data-id="element-12">
                    <div className="absolute top-0 left-0 w-full h-1 bg-[#D4AF37]" data-id="element-13" />
                    DealersChoice
                  </th>
                  <th className="p-6 bg-gray-50 text-gray-500 font-semibold w-1/3" data-id="element-14">
                    Others
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-15">
                {features.map((feature, index) => <motion.tr key={index} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.05
              }} className="hover:bg-gray-50 transition-colors" data-id="element-16">
                    <td className="p-6 text-gray-900 font-medium" data-id="element-17">
                      {feature.name}
                    </td>

                    {/* Us Column */}
                    <td className="p-6 bg-[#0A2540]/5 border-x border-[#0A2540]/10" data-id="element-18">
                      <div className="flex items-center text-[#0A2540] font-bold" data-id="element-19">
                        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-2" data-id="element-20">
                          <Check className="w-4 h-4 text-green-600" data-id="element-21" />
                        </div>
                        Included
                      </div>
                    </td>

                    {/* Them Column */}
                <td className="p-6 text-gray-500" data-id="element-22">
  {feature.them === true ? <div className="flex items-center text-green-600 font-semibold" data-id="element-23">
      <Check className="w-5 h-5 mr-2" data-id="element-24" />
      Included
    </div> : feature.them === false ? <div className="flex items-center text-red-500" data-id="element-25">
      <X className="w-5 h-5 mr-2" data-id="element-26" />
      No
    </div> : <div className="flex items-center" data-id="element-27">
      {(feature.them === 'Rarely' || feature.them === 'Rare') && <X className="w-5 h-5 mr-2 text-red-500" data-id="element-28" />}
      <span data-id="element-29">{feature.them}</span>
    </div>}
                </td>

                  </motion.tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}